import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { Establishment } from './modelo/Establishment';
import { EmissionPoint } from './modelo/EmissionPoint';

@Injectable()
export class BreadcrumbService {

    private titleSource = new Subject<string>();
    private itemsSource = new Subject<MenuItem[]>();
    private pageDescriptionSource = new Subject<string>();
    

    itemsHandler = this.itemsSource.asObservable();

    setItems(items: MenuItem[]) {
        this.itemsSource.next(items);
    }
    setTitle(title: string) {
        this.titleSource.next(title);
    }
    setPageDescription(pageDescription: string) {
        this.pageDescriptionSource.next(pageDescription);
    }
    
}
